import { apiClient } from "@/services/HttpService";

export function loadSpec(projectId) {
  return apiClient.get(`/spec?projectId=${projectId}`);
}

export function saveSpec(projectSpec) {
  return apiClient.post("/spec", projectSpec);
}

export function saveSectionOne(params) {
  return apiClient.post("/project/section-one", params);
}

export function saveAdditionalDocs(params) {
  return apiClient.post("/project/additional-docs", params);
}

export function loadSectionOne(projectId) {
  return apiClient.get(`/project/section-one?projectId=${projectId}`);
}

export function loadSectionTwo(projectId) {
  return apiClient.get(`/project/section-two?projectId=${projectId}`);
}
export function saveSectionTwo(params) {
  return apiClient.post("/project/section-two", params);
}

export function loadSectionThree(projectId) {
  return apiClient.get(`/project/section-three?projectId=${projectId}`);
}
export function saveSectionThree(params) {
  return apiClient.post("/project/section-three", params);
}